import { ENTITY_URL } from "../../../config/config";
import { connection } from "../../../utils/connection";


const graficoPorMotivosDeturnos = async ({ params,token, callbacks }) => {
    const response = await connection({ method: 'POST', url: `${ENTITY_URL.SUPERVISOR.GRAFICOS.MOTIVOS_TURNO}`, extraHeaders: { token: token } , params: params });
    if (typeof callbacks === "function") {
        callbacks(response);
    }
}

export default graficoPorMotivosDeturnos;